const CHANNEL_NAME = 'holzcom-auth-session';
const STORAGE_KEY = 'holzcom-auth-session-event';

export type AuthSessionEvent = {
  type: 'logout';
  id: string;
  at: number;
};

function eventId(): string {
  return `${Date.now()}:${crypto.randomUUID()}`;
}

export function broadcastLogout(): void {
  const event: AuthSessionEvent = { type: 'logout', id: eventId(), at: Date.now() };
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(event);
    channel.close();
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(event));
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage can be unavailable in locked-down/private contexts. The
    // BroadcastChannel path remains the primary same-origin transport.
  }
}

export function subscribeToRemoteLogout(onLogout: () => void): () => void {
  const seen = new Set<string>();
  const accept = (candidate: unknown) => {
    if (!candidate || typeof candidate !== 'object') return;
    const event = candidate as Partial<AuthSessionEvent>;
    if (event.type !== 'logout' || typeof event.id !== 'string' || seen.has(event.id)) return;
    seen.add(event.id);
    onLogout();
  };
  const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : null;
  if (channel) channel.onmessage = (message) => accept(message.data);
  const onStorage = (event: StorageEvent) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try { accept(JSON.parse(event.newValue)); } catch { /* ignore malformed foreign storage */ }
  };
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener('storage', onStorage);
    channel?.close();
  };
}
